module.exports = __webpack_public_path__ + "img/plus.c303deab.svg";